import {
  Home as HomeIcon,
  GridViewOutlined as DashboardIcon,
  TextFieldsRounded as TTSIcon,
  ShoppingCartOutlined as PackageIcon,
  Groups as AffiliateIcon,
  LocalOfferOutlined as LiveSupportIcon,
  PhoneAndroidRounded as MobileAppIcon,
  SubtitlesOutlined as DubbingIcon,
  CardMembershipRounded as CardMembershipRoundedIcon,
  MicRounded as VoiceCloningIcon,
  RecordVoiceOverRounded as VoiceCloningIconMobileSidebar,
  TheatersRounded as DubbingIconMobileSidebar,
  ShoppingCartRounded as PaymentIconMobileSidebar,
  GraphicEqRounded as TTSIconMobileSidebar,
  MovieFilterRounded as MovieFilterRoundedIcon,
  GroupAddRounded as ReferralIcon,
  LocalLibraryRounded as VoiceLibraryIcon,
} from '@mui/icons-material';
import Home from '@src/pages/Home';
import ComingSoon from '@src/pages/ComingSoon';
import TTS from '@src/pages/TTS';
import VoiceCloning from '@src/pages/VoiceCloning';
import Dubbing from '@src/pages/Dubbing';
import Payment from '@src/pages/Payment';
import PaymentHistory from '@src/pages/PaymentHistory';
import MobileApp from '@src/pages/MobileApp';
import ManagerDevice from '@src/pages/ManageDevice';
import ConfigAutoRenew from '@src/pages/ConfigAutoRenew';
import Subscription from '@src/pages/Subscription';
import VoiceCloningCreate from '@src/pages/VoiceCloningCreate';

import Affiliate from '@src/pages/Affiliate';
import AffiliateDetail from '@src/pages/AffliateDetail';
import routes from '@src/constants/route';
import { FEATURE_KEYS } from '@src/configs/featureKeys';
import DubbingProjectDetail from '@src/pages/DubbingProjectDetail';
import Project from '@src/pages/Project';
import ProjectDetail from '@src/pages/ProjectDetail';
import Referral from '@src/pages/Referral';
import EarningsManagement from '@src/pages/EarningsManagement';
import TopPaidEvent from '@src/pages/TopPaidEvent';
import VoiceLibraryPage from '@src/pages/VoiceLibrary';
import VoiceLeaderboard from '@src/pages/VoiceLeaderboard';
import TransactionsHistory from '@src/pages/TransactionsHistory';
import ReferredOrders from '@src/pages/ReferredOrders';
import MobileSubscriptionSuggestion from '@src/containers/NewPricingModelV3/SubscriptionSuggestion/Mobile';
import ListApps from '@src/pages/ListApps';
import AppDetail from '@src/pages/AppDetail';
import EducatorsHome from '@src/pages/EducatorsHome';

const ttsAppRoutes = [
  {
    name: 'home',
    path: routes.HOME,
    component: Home,
    icon: HomeIcon,
    restricted: true,
    isPrivate: true,
    sidebar: true,
  },
  {
    name: 'educatorsHome',
    path: routes.EDUCATORS_HOME,
    component: EducatorsHome,
    exact: true,
    restricted: true,
    isPrivate: true,
    sidebar: false,
    featureKey: FEATURE_KEYS.EDUCATORS_MODE,
  },
  {
    name: 'dashboard',
    path: routes.DASHBOARD,
    component: ComingSoon,
    icon: DashboardIcon,
    exact: true,
    restricted: false,
    isPrivate: true,
    sidebar: false,
  },
  {
    name: 'project',
    path: routes.PROJECTS,
    component: Project,
    icon: MovieFilterRoundedIcon,
    exact: true,
    restricted: true,
    isPrivate: true,
    sidebar: true,
  },
  {
    name: 'projectDetail',
    path: routes.PROJECT_DETAIL,
    component: ProjectDetail,
    icon: MovieFilterRoundedIcon,
    exact: true,
    restricted: true,
    isPrivate: true,
    sidebar: false,
  },
  {
    name: 'appDetail',
    path: routes.APP_DETAIL,
    component: AppDetail,
    icon: MovieFilterRoundedIcon,
    exact: true,
    restricted: true,
    isPrivate: true,
    sidebar: false,
  },
  {
    name: 'convertText',
    path: routes.TTS,
    component: TTS,
    icon: TTSIcon,
    exact: true,
    restricted: true,
    isPrivate: true,
    sidebar: true,
    isMobileSidebar: true,
    labelMobileSidebar: 'STUDIO',
    iconMobileSidebar: TTSIconMobileSidebar,
  },
  {
    name: 'voiceCloning',
    path: routes.VOICE_CLONING_VOICES,
    component: VoiceCloning,
    icon: VoiceCloningIcon,
    exact: true,
    restricted: true,
    isPrivate: true,
    sidebar: true,
    beta: true,
    isMobileSidebar: true,
    labelMobileSidebar: 'voiceCloning',
    iconMobileSidebar: VoiceCloningIconMobileSidebar,
  },
  {
    name: 'voiceLibrary',
    path: routes.VOICE_LIBRARY,
    component: VoiceLibraryPage,
    icon: VoiceLibraryIcon,
    exact: true,
    restricted: true,
    isPrivate: true,
    sidebar: true,
  },
  {
    name: 'voiceCloningCreate',
    path: routes.VOICE_CLONING_CREATE,
    component: VoiceCloningCreate,
    icon: VoiceCloningIcon,
    exact: true,
    restricted: false,
    isPrivate: true,
    sidebar: false,
  },
  {
    name: 'voiceCloningVoices',
    path: routes.VOICE_CLONING_VOICE_DETAIL,
    component: VoiceCloningCreate,
    icon: VoiceCloningIcon,
    exact: true,
    restricted: false,
    isPrivate: true,
    sidebar: false,
  },
  {
    name: 'dubbing',
    path: routes.DUBBING,
    component: Dubbing,
    icon: DubbingIcon,
    exact: true,
    restricted: false,
    isPrivate: true,
    sidebar: true,
    beta: false,
    featureKey: FEATURE_KEYS.DUBBING,
    isMobileSidebar: true,
    labelMobileSidebar: 'DUBBING',
    iconMobileSidebar: DubbingIconMobileSidebar,
  },
  {
    name: 'buyPackage',
    path: routes.PAYMENT,
    component: Payment,
    icon: PackageIcon,
    exact: true,
    restricted: false,
    isPrivate: true,
    sidebar: true,
    banner: true,
    isMobileSidebar: true,
    labelMobileSidebar: 'buyPackage',
    iconMobileSidebar: PaymentIconMobileSidebar,
  },
  {
    name: 'buyPackage',
    path: routes.PAYMENT_HISTORY,
    component: PaymentHistory,
    icon: PackageIcon,
    exact: true,
    restricted: false,
    isPrivate: true,
    sidebar: false,
    banner: true,
  },
  {
    name: 'mobileApp',
    path: routes.MOBILE_APP,
    component: MobileApp,
    icon: MobileAppIcon,
    exact: true,
    restricted: true,
    isPrivate: true,
    sidebar: true,
  },
  {
    name: 'affiliate',
    path: routes.AFFILIATE,
    subPaths: [routes.AFFILIATE_DETAIL],
    component: Affiliate,
    icon: AffiliateIcon,
    exact: true,
    restricted: false,
    isPrivate: true,
    sidebar: true,
  },
  {
    name: 'affiliate-detail',
    path: routes.AFFILIATE_DETAIL,
    component: AffiliateDetail,
    icon: AffiliateIcon,
    exact: true,
    restricted: false,
    isPrivate: true,
    sidebar: false,
  },
  {
    name: 'onlineSupport',
    path: routes.LIVE_SUPPORT,
    component: ComingSoon,
    icon: LiveSupportIcon,
    exact: true,
    restricted: false,
    isPrivate: true,
    sidebar: false,
  },
  {
    name: 'manageDevice',
    path: routes.MANAGE_DEVICE,
    component: ManagerDevice,
    exact: true,
    restricted: false,
    isPrivate: true,
    sidebar: false,
  },
  {
    name: 'configAutoRenew',
    path: routes.CONFIG_AUTO_RENEW,
    component: ConfigAutoRenew,
    exact: true,
    restricted: false,
    isPrivate: true,
    sidebar: false,
  },
  {
    name: 'subscription',
    path: routes.SUBSCRIPTION,
    component: Subscription,
    icon: CardMembershipRoundedIcon,
    exact: true,
    restricted: true,
    isPrivate: true,
    sidebar: false,
    dubbingSidebar: false,
  },
  {
    name: 'referral',
    path: routes.REFERRAL,
    icon: ReferralIcon,
    exact: true,
    restricted: false,
    isPrivate: true,
    sidebar: true,
    component: Referral,
  },
  {
    name: 'topPaidEvent',
    path: routes.TOP_PAID_EVENT,
    exact: true,
    restricted: false,
    isPrivate: true,
    sidebar: false,
    featureKey: FEATURE_KEYS.TOP_PAID_EVENT,
    component: TopPaidEvent,
  },
  {
    name: 'earningsManagement',
    path: routes.EARNINGS_MANAGEMENT,
    exact: true,
    restricted: false,
    isPrivate: true,
    sidebar: true,
    featureKey: FEATURE_KEYS.EARNINGS_MANAGEMENT,
    component: EarningsManagement,
  },
  {
    name: 'apiIntegration',
    path: routes.LIST_APPS,
    exact: true,
    restricted: false,
    isPrivate: true,
    sidebar: false,
    featureKey: FEATURE_KEYS.LIST_APPS,
    component: ListApps,
  },
  {
    name: 'leaderboard',
    path: routes.VOICE_LEADERBOARD,
    component: VoiceLeaderboard,
    restricted: true,
    isPrivate: true,
  },
  {
    name: 'mobileSubscriptionSuggestion',
    path: routes.MOBILE_SUBSCRIPTION_SUGGESTION,
    component: MobileSubscriptionSuggestion,
    restricted: true,
    isPrivate: true,
  },
  {
    name: 'transactionsHistory',
    path: routes.TRANSACTIONS_HISTORY,
    exact: true,
    restricted: false,
    isPrivate: true,
    sidebar: true,
    component: TransactionsHistory,
  },
  {
    name: 'referredOrders',
    path: routes.REFERRED_ORDERS,
    exact: true,
    restricted: false,
    isPrivate: true,
    component: ReferredOrders,
  },
];

const dubbingAppRoutes = [
  {
    name: 'home',
    path: routes.DUBBING_HOME,
    component: Home,
    icon: HomeIcon,
    restricted: true,
    isPrivate: true,
    sidebar: true,
  },
  {
    name: 'dubbingRouteName',
    path: routes.HOME_DUBBING,
    component: Dubbing,
    icon: DubbingIcon,
    exact: true,
    restricted: false,
    isPrivate: true,
    sidebar: true,
    beta: false,
    featureKey: FEATURE_KEYS.DUBBING,
  },
  {
    name: 'buyPackage',
    path: routes.PAYMENT_DUBBING,
    component: Payment,
    icon: PackageIcon,
    exact: true,
    restricted: false,
    isPrivate: true,
    sidebar: true,
    banner: true,
  },
  {
    name: 'buyPackage',
    path: routes.PAYMENT_HISTORY_DUBBING,
    component: PaymentHistory,
    icon: PackageIcon,
    exact: true,
    restricted: false,
    isPrivate: true,
    sidebar: false,
    banner: true,
  },
  {
    name: 'affiliate',
    path: routes.AFFILIATE_DUBBING,
    subPaths: [routes.AFFILIATE_DETAIL_DUBBING],
    component: Affiliate,
    icon: AffiliateIcon,
    exact: true,
    restricted: false,
    isPrivate: true,
    sidebar: true,
  },
  {
    name: 'affiliate-detail',
    path: routes.AFFILIATE_DETAIL_DUBBING,
    component: AffiliateDetail,
    icon: AffiliateIcon,
    exact: true,
    restricted: false,
    isPrivate: true,
    sidebar: false,
  },
  {
    name: 'subscription',
    path: routes.SUBSCRIPTION_DUBBING,
    component: Subscription,
    icon: CardMembershipRoundedIcon,
    exact: true,
    restricted: true,
    isPrivate: true,
    sidebar: false,
    dubbingSidebar: false,
  },
  {
    name: 'dubbing-project-detail',
    path: routes.DUBBING_PROJECT_DETAIL,
    component: DubbingProjectDetail,
    icon: CardMembershipRoundedIcon,
    exact: true,
    restricted: true,
    isPrivate: true,
    sidebar: false,
    dubbingSidebar: false,
  },
];

export { ttsAppRoutes, dubbingAppRoutes };
